
import axios from 'axios'
import router from '../router'
// const apiUrl = 'http://5.5.5.5:8088/api/'
const apiUrl = 'https://harhashxray.com/api/api/'
export default {
  actions: {
    // ==============================================================
    callApi ({commit}, { url, data }) {
      return new Promise((resolve, reject) => {
        const token = sessionStorage.getItem('token')
        axios.post(apiUrl + url, {
          'token': token,
          data
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            // --------------------Unauthorized------------------
            if (err.response.status === 500) {
              router.push({path: 'Err500'})
            }
            // --------------------page not found------------------
            if (err.response.status === 404) {
              router.push({path: 'Err404'})
            }
            // -------------------user not login Unauthorized-------------------
            if (err.response.status === 401) {
              router.push({path: 'Err401'})
            }
            reject(err.response.data.errors)
          })
      })
    },
    // ==============================================================
    login ({commit}, {data}) {
      return new Promise((resolve, reject) => {
        axios.post(apiUrl + 'auth/login', {
          company_id: data.companyID,
          username: data.userName,
          password: data.password
        })
          .then(res => {
            sessionStorage.setItem('isLogin', 'True')
            sessionStorage.setItem('token', res.data.access_token)
            sessionStorage.setItem('avt_img', res.data.av_img)
            sessionStorage.setItem('name', res.data.name)
            resolve(res.data)
          })
          .catch(err => {
            reject(err.response.data.errors)
          })
      })
    },
    // ==============================================================
    uploadFileApi ({commit}, { url, imgSource, type, id }) {
      return new Promise((resolve, reject) => {
        const token = sessionStorage.getItem('token')
        let img = imgSource.target.files[0]
        let fd = new FormData()
        if (id == null) {
          id = 0
        }

        fd.append('image', img)
        fd.append('type', type)
        fd.append('token', token)
        fd.append('id', id)

        axios.post(apiUrl + url, fd)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            // --------------------Unauthorized------------------
            if (err.response.status === 500) {
              router.push({path: 'Err500'})
            }
            // --------------------page not found------------------
            if (err.response.status === 404) {
              router.push({path: 'Err404'})
            }
            // -------------------user not login Unauthorized-------------------
            if (err.response.status === 401) {
              router.push({path: 'Err401'})
            }
            reject(err.response.data.errors)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Api.js